import $ from 'jquery'

export class NavTop {

  constructor () {
    this.$navTop = $('.nav-top')
    this.$header = $('header.header')

    if (!this.$navTop.length || !this.$header.length) {
      return
    }

    this.classInBurger = 'in-burger'
    this.mobileAnchorSelector = 'nav.header-primary'

    // Ancre permettant de remettre le nav-top à sa place initiale en desktop
    this.$anchor = $('<span hidden data-nav-top-anchor></span>')
    this.$anchor.insertAfter(this.$navTop)

    this.mediaQuery = window.matchMedia('(max-width: 79.8125rem)')

    this.handleChange = this.handleChange.bind(this)
    if (typeof this.mediaQuery.addEventListener === 'function') {
      this.mediaQuery.addEventListener('change', this.handleChange)
    } else {
      this.mediaQuery.addListener(this.handleChange)
    }

    this.handleChange(this.mediaQuery)
  }

  handleChange (mql) {
    if (mql.matches) {
      this.moveToBurger()
    } else {
      this.moveToTop()
    }
  }

  moveToBurger () {
    const $target = this.$header.find(this.mobileAnchorSelector)

    if (!$target.length) {
      return
    }

    this.$navTop.addClass(this.classInBurger)
    $target.append(this.$navTop)
  }

  moveToTop () {
    this.$navTop.removeClass(this.classInBurger)
    this.$anchor.before(this.$navTop)
  }
}
